import { useEffect } from 'react';
import { api } from '@/lib/api';

/**
 * Fetches admin-configured live-chat widget code from /api/public/chat-widget
 * and injects it into the document. Runs once on mount for the whole app.
 * Supports raw <script> HTML or provider snippets (Tawk.to / Crisp / Intercom / Tidio / Twilio / custom).
 */
export default function ChatWidget() {
  useEffect(() => {
    let removed = false;
    const injected = [];
    (async () => {
      try {
        const { data } = await api.get('/public/chat-widget');
        if (!data?.enabled || !data?.code || removed) return;
        // Parse the raw HTML — extract <script> tags separately so they actually execute
        const container = document.createElement('div');
        container.innerHTML = data.code;
        const scripts = Array.from(container.querySelectorAll('script'));
        // First append any non-script HTML (some widgets need a div anchor)
        scripts.forEach(s => s.remove());
        if (container.innerHTML.trim()) {
          const wrap = document.createElement('div');
          wrap.dataset.chatWidget = '1';
          wrap.innerHTML = container.innerHTML;
          document.body.appendChild(wrap);
          injected.push(wrap);
        }
        // Now recreate script tags so browser executes them
        scripts.forEach(orig => {
          const s = document.createElement('script');
          Array.from(orig.attributes).forEach(a => s.setAttribute(a.name, a.value));
          s.text = orig.text;
          s.dataset.chatWidget = '1';
          document.body.appendChild(s);
          injected.push(s);
        });
      } catch {}
    })();
    return () => { removed = true; injected.forEach(el => el.remove()); };
  }, []);
  return null;
}
